<template>
  <v-chart :options="chartOptions" autoresize class="dates-of-month-chart" />
</template>
<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";

export default {
  components: {
    "v-chart": ECharts,
  },
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    month: {
      type: Number,
      default: new Date().getMonth(),
    },
    year: {
      type: Number,
      default: new Date().getFullYear(),
    },
  },
  computed: {
    chartOptions() {
      const daysInMonth = new Date(this.year, this.month + 1, 0).getDate();
      const daysData = new Array(daysInMonth).fill(0);

      this.chartData.forEach((item) => {
        const date = new Date(parseInt(item.dateTime));
        // console.log(
        //   "date",
        //   date.getDate(),
        //   date.getMonth(),
        //   date.getFullYear(),
        //   this.month,
        //   this.year
        // );
        if (
          date.getMonth() === this.month &&
          date.getFullYear() === this.year
        ) {
          const day = date.getDate() - 1;
          daysData[day]++;
        }
      });

      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["Daily Counts"],
        },
        grid: {
          // Adjusting the grid to ensure proper alignment
          left: "20px",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [...Array(daysInMonth).keys()].map((day) => day + 1),
          name: "Date",
          axisLabel: {
            rotate: 0,
          },
        },
        yAxis: {
          type: "value",
          name: "Count",
          minInterval: 1,
          axisLabel: {
            formatter: "{value}",
          },
        },
        series: [
          {
            name: "Daily Counts",
            type: "bar",
            data: daysData,
            itemStyle: {
              color: "#4186f4",
            },
          },
        ],
        label: {
          show: true,
          position: "top",
          color: "#000",
        },
      };
    },
  },
};
</script>
<style scoped>
.dates-of-month-chart {
  width: 100%;
  height: 400px;
}
</style>
